// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_QDCxa","avatar":"index_avatar_1XtpV","menuIcon":"index_menuIcon_2mo5W","neoNotificationTable":"index_neoNotificationTable_1tY_L"};